// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__SrJR4","label":"Labeled_label__3QXYW","divider":"Labeled_divider__3jjWX"};